import type { LucideProps, SVGAttributes } from "lucide-solid";
import { splitProps } from "solid-js";

const defaultAttributes: SVGAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
};

interface ModelFileIconProps {
    letters: [string, string];
}

export function ModelFileIcon(props: LucideProps & ModelFileIconProps) {
    const [localProps, rest] = splitProps(props, [
        "absoluteStrokeWidth",
        "children",
        "class",
        "color",
        "letters",
        "size",
        "strokeWidth",
    ]);
    return (
        <svg
            {...defaultAttributes}
            width={localProps.size ?? defaultAttributes.width}
            height={localProps.size ?? defaultAttributes.height}
            stroke={localProps.color ?? defaultAttributes.stroke}
            stroke-width={
                localProps.absoluteStrokeWidth
                    ? (Number(localProps.strokeWidth ?? defaultAttributes["stroke-width"]) * 24) /
                      Number(localProps.size)
                    : Number(localProps.strokeWidth ?? defaultAttributes["stroke-width"])
            }
            class="lucide lucide-icon lucide-file-catcolab"
            classList={{ [localProps.class ?? ""]: localProps.class != null }}
            {...rest}
        >
            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
            <path d="m14 2v5a1 1 0 0 0 1 1h5" />
            <text
                x="14"
                y="18"
                font-size="13px"
                font-weight="bold"
                stroke-width="0"
                text-anchor="end"
                dominant-baseline="auto"
                text-rendering="optimizeLegibility"
                shape-rendering="crispEdges"
                font-family="'Source Code Pro'"
                fill={localProps.color ?? defaultAttributes.stroke}
            >
                {localProps.letters[0]}
            </text>
            <text
                x="18"
                y="18"
                font-size="8px"
                font-weight="bold"
                stroke-width="0"
                text-anchor="end"
                dominant-baseline="auto"
                text-rendering="optimizeLegibility"
                shape-rendering="crispEdges"
                font-family="'Source Code Pro'"
                fill={localProps.color ?? defaultAttributes.stroke}
            >
                {localProps.letters[1]}
            </text>
        </svg>
    );
}
